import ContentCard from "../../../Components/ContentCard";
import PDFPageManager from "../../../Components/PDFPageManager";
import { Helmet } from "react-helmet-async";
const Manager = () => {
    return (
        <>
            <Helmet>
                <title>PDF Seiten löschen & neu anordnen – kostenlos online | FileForge</title>
                <meta name="description" content="Ordnen Sie PDF-Seiten neu an oder löschen Sie einzelne Seiten – kostenlos, ohne Anmeldung, direkt im Browser." />
                <link rel="canonical" href="https://www.file-forge.org/pdf-seiten-bearbeiten" />
            </Helmet>

            <ContentCard
                title="Seiten neu anordnen und löschen"
                description="Ordnen Sie die Seiten Ihrer PDF-Dateien neu an oder löschen Sie unerwünschte Seiten."
                baseClases="p-6 m-2 border flex flex-col gap-4 w-full"
            >
                <PDFPageManager />
            </ContentCard>
        </>

    )
}

export default Manager